import {
  Experiment,
  AmplitudeUserProvider,
} from '@amplitude/experiment-js-client';
import isMocked from 'lib/isMocked';
import isQABot from 'lib/isQABot';

const isProd = () => process.env.NODE_ENV === 'production';
const defaultEnabled = isProd() && !isQABot() && !isMocked();

export class ExperimentClient {
  get _instance() {
    return this._enabled ? this._client : null;
  }

  /**
   * Fetching a users experiment uses a promise to resolve meaning we need to make sure we
   * keep track of wether the users experiment variant has been returned
   */
  get isLoading() {
    return this._enabled ? this._loading : false;
  }

  /**
   * Initialize the experiment SDK. See https://developers.experiment.amplitude.com/docs/javascript-client-sdk#initialization
   * @param {boolean} enabled - Wether or not to enable experiments.
   * @param {debug} debug - Show debug logs.
   * @param string environmentKey - The environment key for amplitude experiments.
   * @param {AmplitudeClient} amplitudeInstance - Used for connecting analytics SDK to the experiment SDK.
   */
  init({ enabled, debug, environmentKey, amplitudeInstance }) {
    if (this._instance) return;

    this._loading = true;

    this._enabled = enabled || defaultEnabled;
    this._debug = debug || false;
    this._client = Experiment.initialize(environmentKey, { debug });

    if (amplitudeInstance) {
      this._instance?.setUserProvider(
        new AmplitudeUserProvider(amplitudeInstance)
      );
    }

    this._instance?.fetch().then(() => {
      this._loading = false;
    });
  }

  /**
   * Gets the user's variant for a specific experiment
   * @param string experimentName - The name of the experiment to fetch variants for. Usually dash case `experiment-name`.
   */
  variant(experimentName) {
    return this._instance?.variant(experimentName);
  }
}
